(() => {
  const activeIndex = (items) => {
    const threshold = window.innerHeight * 0.38;
    let index = 0;
    items.forEach((item, itemIndex) => {
      if (item.getBoundingClientRect().top <= threshold) index = itemIndex;
    });
    return index;
  };

  const applyActive = (state, index) => {
    if (index === state.lastIndex) return;
    state.lastIndex = index;
    state.items.forEach((item, itemIndex) => {
      const active = itemIndex === index;
      item.classList.toggle('is-active', active);
      item.toggleAttribute('aria-current', active);
      if (active) item.setAttribute('aria-current', 'step');
      const image = item.querySelector('.what-to-expect__dot-icon');
      if (image) image.src = active ? state.activeSource : state.inactiveSource;
    });
  };

  const initializeTimeline = (root) => {
    if (root.dataset.timelineReady === 'true') return;
    const items = Array.from(root.querySelectorAll('.what-to-expect__item'));
    const activeSource = root.dataset.activeIcon;
    const inactiveSource = root.dataset.inactiveIcon;
    if (!items.length || !activeSource || !inactiveSource) return;
    root.dataset.timelineReady = 'true';
    const events = new AbortController();
    const state = { items, activeSource, inactiveSource, lastIndex: -1, frameId: null };
    const update = () => {
      if (state.frameId) return;
      state.frameId = requestAnimationFrame(() => {
        state.frameId = null;
        applyActive(state, activeIndex(items));
      });
    };
    window.addEventListener('scroll', update, { passive: true, signal: events.signal });
    window.addEventListener('resize', update, { signal: events.signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      events.abort();
      if (state.frameId) cancelAnimationFrame(state.frameId);
    }, { signal: events.signal });
    update();
  };

  document.querySelectorAll('.what-to-expect').forEach(initializeTimeline);
})();
